"use client";

import { c as _c } from "react/compiler-runtime";
import { LocationCardNotice } from "../../components/location-notice";
import { LocationCard } from "../../components/self-schedule-card";
import { calculateDistance } from "../../utils";
import { canLocationHostServices } from "../services-step/components/helpers";
import { useMemo, useState } from "react";
import AddressInput from "@/components/self-schedule/address-input";
import { Button, Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui";
import { useSelfScheduleContext } from "@/contexts/self-schedule-provider";
import { useFrontPage } from "@/hooks/self-schedule/use-front-page";
import { usePatientVerification } from "@/hooks/self-schedule/use-patient-verification";
import { formatAddress, formatPhoneNumber } from "@/lib/format-data";
import { noProvidersUntil, selectionShiftStart } from "@/lib/self-schedule-next-shift";
import { cx } from "@/lib/tailwind-utils";
import { LocationWithVisibility, PublicLocationDetail } from "@/types/location";
import LocationsMap from "./locations-map";
import { LocationType } from "@/stores/self-schedule-store";
const Locations = t0 => {
  const $ = _c(114);
  const {
    className
  } = t0;
  const [selectedLocationForDetails, setSelectedLocationForDetails] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const {
    data: frontPageData,
    isLoading
  } = useFrontPage();
  const {
    setSelectedLocationId,
    userLocation,
    setUserLocation,
    locationType,
    selectedServices,
    selectedLocation,
    setLocationType,
    shouldShowLocationBeforeService,
    shouldExposeLocationTypeChoice,
    requestedAssignments,
    bookingEvent,
    selectedProvider
  } = useSelfScheduleContext();
  const {
    patient
  } = usePatientVerification();
  const previousLocationId = patient?.mostRecentAppointmentLocationId;
  const locationBeforeService = shouldShowLocationBeforeService;
  frontPageData?.locations;
  frontPageData?.services;
  const services = selectedServices?.length ? selectedServices : frontPageData?.services;
  let t1;
  if ($[0] !== locationBeforeService || $[1] !== selectedLocation || $[2] !== services) {
    t1 = locationBeforeService && selectedLocation ? services?.filter(s => s.locationIds.length === 0 || s.locationIds.includes(selectedLocation.id)) : services;
    $[0] = locationBeforeService;
    $[1] = selectedLocation;
    $[2] = services;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const relevantServices = t1;
  let t2;
  let t3;
  if ($[4] !== frontPageData?.locations || $[5] !== relevantServices) {
    const locations = frontPageData?.locations.filter(location => relevantServices?.some(service => service.locationIds.length === 0 || service.locationIds.includes(location.id)));
    t2 = (relevantServices?.some(_temp) || locations?.some(_temp2)) ?? false;
    t3 = locations?.some(_temp3) ?? false;
    $[4] = frontPageData?.locations;
    $[5] = relevantServices;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      selectedServicesAvailableVirtual: t2,
      selectedServicesAvailableInPerson: t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    selectedServicesAvailableVirtual,
    selectedServicesAvailableInPerson
  } = t4;
  let t5;
  bb0: {
    if (!frontPageData?.locations || !frontPageData?.services) {
      let t6;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[11] = t6;
      } else {
        t6 = $[11];
      }
      t5 = t6;
      break bb0;
    }
    const hasSelectedServices = !!selectedServices?.length;
    if (!hasSelectedServices && !locationBeforeService) {
      let t6;
      if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[12] = t6;
      } else {
        t6 = $[12];
      }
      t5 = t6;
      break bb0;
    }
    let t6;
    if ($[13] !== frontPageData.locations || $[14] !== frontPageData.services || $[15] !== hasSelectedServices || $[16] !== locationBeforeService || $[17] !== locationType || $[18] !== selectedServices || $[19] !== shouldExposeLocationTypeChoice || $[20] !== userLocation) {
      let t7;
      if ($[22] !== frontPageData.services || $[23] !== locationBeforeService || $[24] !== locationType || $[25] !== shouldExposeLocationTypeChoice) {
        t7 = location_2 => {
          if (locationBeforeService && locationType === null && shouldExposeLocationTypeChoice && location_2.isVirtual) {
            return false;
          }
          if (locationType === LocationType.VIRTUAL && !location_2.isVirtual) {
            return false;
          }
          if (locationType === LocationType.IN_PERSON && location_2.isVirtual) {
            return false;
          }
          if (frontPageData?.services.every(service_1 => service_1.locationIds.length > 0 && !service_1.locationIds.includes(location_2.id))) {
            return false;
          }
          return true;
        };
        $[22] = frontPageData.services;
        $[23] = locationBeforeService;
        $[24] = locationType;
        $[25] = shouldExposeLocationTypeChoice;
        $[26] = t7;
      } else {
        t7 = $[26];
      }
      let t8;
      if ($[27] !== hasSelectedServices || $[28] !== selectedServices || $[29] !== userLocation) {
        t8 = location_3 => {
          const isServiceAvailable = hasSelectedServices ? canLocationHostServices(location_3, selectedServices ?? []) : true;
          let distance;
          if (isServiceAvailable && userLocation && location_3.latitude && location_3.longitude) {
            distance = calculateDistance(userLocation.lat, userLocation.lng, location_3.latitude, location_3.longitude);
          }
          return {
            ...location_3,
            distance,
            isServiceAvailable
          };
        };
        $[27] = hasSelectedServices;
        $[28] = selectedServices;
        $[29] = userLocation;
        $[30] = t8;
      } else {
        t8 = $[30];
      }
      t6 = frontPageData.locations.filter(t7).map(t8).sort(_temp4);
      $[13] = frontPageData.locations;
      $[14] = frontPageData.services;
      $[15] = hasSelectedServices;
      $[16] = locationBeforeService;
      $[17] = locationType;
      $[18] = selectedServices;
      $[19] = shouldExposeLocationTypeChoice;
      $[20] = userLocation;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    const processedLocations = t6;
    t5 = processedLocations;
  }
  const allLocationsWithAvailability = t5;
  let t6;
  if ($[31] !== allLocationsWithAvailability) {
    t6 = allLocationsWithAvailability.findIndex(_temp5);
    $[31] = allLocationsWithAvailability;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  const firstAvailableLocationIndex = t6;
  let t7;
  if ($[33] !== setUserLocation) {
    t7 = addressData => {
      if (addressData.latitude && addressData.longitude) {
        setUserLocation({
          lat: addressData.latitude,
          lng: addressData.longitude
        });
      }
    };
    $[33] = setUserLocation;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  const handleAddressChange = t7;
  if (!frontPageData || isLoading) {
    return null;
  }
  let t8;
  if ($[35] !== allLocationsWithAvailability || $[36] !== setSelectedLocationId) {
    t8 = locationId => {
      const location_4 = allLocationsWithAvailability.find(loc_0 => loc_0.id === locationId);
      if (location_4 && location_4.isServiceAvailable) {
        setSelectedLocationId(locationId, location_4.name);
      }
    };
    $[35] = allLocationsWithAvailability;
    $[36] = setSelectedLocationId;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  const handleLocationClick = t8;
  let t9;
  if ($[38] !== frontPageData?.locations) {
    t9 = (e, locationId_0) => {
      e.stopPropagation();
      e.preventDefault();
      const location_5 = frontPageData?.locations.find(loc_1 => loc_1.id === locationId_0);
      if (location_5) {
        setSelectedLocationForDetails(location_5);
        setIsDetailsModalOpen(true);
      }
    };
    $[38] = frontPageData?.locations;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  const handleInfoClick = t9;
  let t10;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setIsDetailsModalOpen(false);
      setSelectedLocationForDetails(null);
    };
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  const closeDetailsModal = t10;
  let t11;
  if ($[41] !== className) {
    t11 = cx("motion-ease-spring-bouncy", "motion-scale-in-105 motion-opacity-in-85", className);
    $[41] = className;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <h1 className="text-h1 text-foreground">Choose a Location</h1>;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex items-center justify-between"><p className="text-body text-muted-foreground">Where would you like to visit?</p></div>;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== allLocationsWithAvailability || $[46] !== handleAddressChange || $[47] !== handleLocationClick || $[48] !== locationType) {
    t14 = locationType !== LocationType.VIRTUAL && <><AddressInput onAddressChange={handleAddressChange} placeholder="Enter your address to find nearby locations" label="Your Address" className="max-w-md" /><div className="mt-2 space-y-4">{allLocationsWithAvailability.length > 0 && <LocationsMap locations={allLocationsWithAvailability.filter(_temp6)} onLocationSelect={handleLocationClick} />}</div></>;
    $[45] = allLocationsWithAvailability;
    $[46] = handleAddressChange;
    $[47] = handleLocationClick;
    $[48] = locationType;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== locationType || $[51] !== selectedServicesAvailableVirtual || $[52] !== setLocationType) {
    t15 = selectedServicesAvailableVirtual && locationType === LocationType.IN_PERSON && <Button onClick={() => {
      setLocationType(LocationType.VIRTUAL);
    }} variant="ghost" className={cx("hidden px-0 text-left", "md:flex", "motion-preset-slide-right-sm transition-all ease-in-out motion-duration-100/scale", "origin-top", "hover:px-2")}><div className="flex flex-col">Switch to a telehealth appointment?<span className="text-caption text-muted-foreground">Telehealth appointments tend to have more availability.</span></div></Button>;
    $[50] = locationType;
    $[51] = selectedServicesAvailableVirtual;
    $[52] = setLocationType;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== locationType || $[55] !== selectedServicesAvailableInPerson || $[56] !== setLocationType) {
    t16 = selectedServicesAvailableInPerson && locationType === LocationType.VIRTUAL && <Button onClick={() => {
      setLocationType(LocationType.IN_PERSON);
    }} variant="ghost" className={cx("hidden px-0 text-left", "md:flex", "motion-preset-slide-right-sm transition-all ease-in-out motion-duration-100/scale", "origin-top", "hover:px-2")}><div className="flex flex-col">Switch to an in-person appointment?</div></Button>;
    $[54] = locationType;
    $[55] = selectedServicesAvailableInPerson;
    $[56] = setLocationType;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  let t17;
  if ($[58] !== t14 || $[59] !== t15 || $[60] !== t16) {
    t17 = <div className="mt-4">{t14}{t15}{t16}</div>;
    $[58] = t14;
    $[59] = t15;
    $[60] = t16;
    $[61] = t17;
  } else {
    t17 = $[61];
  }
  let t18;
  if ($[62] !== allLocationsWithAvailability || $[63] !== bookingEvent || $[64] !== firstAvailableLocationIndex || $[65] !== frontPageData || $[66] !== handleInfoClick || $[67] !== handleLocationClick || $[68] !== locationType || $[69] !== previousLocationId || $[70] !== requestedAssignments || $[71] !== selectedLocation?.id || $[72] !== selectedProvider?.id || $[73] !== selectedServicesAvailableInPerson || $[74] !== selectedServicesAvailableVirtual || $[75] !== setLocationType) {
    t18 = allLocationsWithAvailability?.map((location_6, index) => {
      const isSelected = selectedLocation?.id === location_6.id;
      const isAvailable = location_6.isServiceAvailable;
      const providersBack = frontPageData.nextShiftStarts && isAvailable && !bookingEvent ? noProvidersUntil(selectionShiftStart({
        nextShiftStarts: frontPageData.nextShiftStarts[location_6.id] ?? {},
        assignments: requestedAssignments,
        services: frontPageData.services,
        providers: frontPageData.providers,
        locationId: location_6.id,
        pickedProviderId: selectedProvider?.id
      }), location_6.timezone) : null;
      return <div key={location_6.id}><LocationCard isPreviousAppointment={previousLocationId === location_6.id} location={location_6} onLocationClick={handleLocationClick} isSelected={isSelected} disabled={!isAvailable} onInfoClick={handleInfoClick} animationDelay={!isSelected ? index * 150 + 50 : undefined} notice={providersBack && <LocationCardNotice until={providersBack} isVirtual={location_6.isVirtual} />} />{firstAvailableLocationIndex === index && selectedServicesAvailableVirtual && locationType === LocationType.IN_PERSON && <Button variant="ghost" onClick={() => {
          setLocationType(LocationType.VIRTUAL);
        }} className={cx("w-full", "md:hidden", "motion-preset-slide-right-sm transition-all ease-in-out motion-duration-100/scale", "origin-top")} style={{
          animationDelay: `${index * 150 + 50}ms`
        }}><div className="flex flex-col">Switch to a telehealth appointment?<span className="text-caption text-muted-foreground">Telehealth appointments tend to have more availability.</span></div></Button>}{firstAvailableLocationIndex === index && selectedServicesAvailableInPerson && locationType === LocationType.VIRTUAL && <Button variant="ghost" onClick={() => {
          setLocationType(LocationType.IN_PERSON);
        }} className={cx("w-full", "md:hidden", "motion-preset-slide-right-sm transition-all ease-in-out motion-duration-100/scale", "origin-top")} style={{
          animationDelay: `${index * 150 + 50}ms`
        }}><div className="flex flex-col">Switch to an in-person appointment?</div></Button>}</div>;
    });
    $[62] = allLocationsWithAvailability;
    $[63] = bookingEvent;
    $[64] = firstAvailableLocationIndex;
    $[65] = frontPageData;
    $[66] = handleInfoClick;
    $[67] = handleLocationClick;
    $[68] = locationType;
    $[69] = previousLocationId;
    $[70] = requestedAssignments;
    $[71] = selectedLocation?.id;
    $[72] = selectedProvider?.id;
    $[73] = selectedServicesAvailableInPerson;
    $[74] = selectedServicesAvailableVirtual;
    $[75] = setLocationType;
    $[76] = t18;
  } else {
    t18 = $[76];
  }
  let t19;
  if ($[77] !== t18) {
    t19 = <div className="mt-2 grid grid-cols-1 gap-4 md:grid-cols-2">{t18}</div>;
    $[77] = t18;
    $[78] = t19;
  } else {
    t19 = $[78];
  }
  const t20 = selectedLocationForDetails?.name;
  let t21;
  if ($[79] !== t20) {
    t21 = <DialogHeader><DialogTitle>{t20}</DialogTitle></DialogHeader>;
    $[79] = t20;
    $[80] = t21;
  } else {
    t21 = $[80];
  }
  let t22;
  if ($[81] !== selectedLocationForDetails) {
    t22 = selectedLocationForDetails?.photoUrl && <img src={selectedLocationForDetails.photoUrl} alt={selectedLocationForDetails.name} className="h-32 w-full rounded-lg object-cover" />;
    $[81] = selectedLocationForDetails;
    $[82] = t22;
  } else {
    t22 = $[82];
  }
  let t23;
  if ($[83] !== selectedLocationForDetails) {
    t23 = selectedLocationForDetails?.description && <p className="whitespace-pre-wrap">{selectedLocationForDetails.description}</p>;
    $[83] = selectedLocationForDetails;
    $[84] = t23;
  } else {
    t23 = $[84];
  }
  let t24;
  if ($[85] !== selectedLocationForDetails) {
    t24 = selectedLocationForDetails && (selectedLocationForDetails.isVirtual ? <p className="font-semibold">This will be a telehealth appointment</p> : <div><p className="font-medium">Address:</p><p className="capitalize">{formatAddress(selectedLocationForDetails.addressLineOne, selectedLocationForDetails.city, selectedLocationForDetails.state, selectedLocationForDetails.zipCode, selectedLocationForDetails.addressLineTwo)}</p></div>);
    $[85] = selectedLocationForDetails;
    $[86] = t24;
  } else {
    t24 = $[86];
  }
  let t25;
  if ($[87] !== selectedLocationForDetails) {
    t25 = selectedLocationForDetails?.phoneNumber && <div><p className="font-medium">Phone:</p><p>{formatPhoneNumber(selectedLocationForDetails.phoneNumber)}</p></div>;
    $[87] = selectedLocationForDetails;
    $[88] = t25;
  } else {
    t25 = $[88];
  }
  let t26;
  if ($[89] !== t23 || $[90] !== t24 || $[91] !== t25) {
    t26 = <div className="space-y-2 text-body">{t23}{t24}{t25}</div>;
    $[89] = t23;
    $[90] = t24;
    $[91] = t25;
    $[92] = t26;
  } else {
    t26 = $[92];
  }
  let t27;
  if ($[93] !== t22 || $[94] !== t26) {
    t27 = <DialogBody className="space-y-4">{t22}{t26}</DialogBody>;
    $[93] = t22;
    $[94] = t26;
    $[95] = t27;
  } else {
    t27 = $[95];
  }
  let t28;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Button variant="secondary" onClick={closeDetailsModal}>Close</Button>;
    $[96] = t28;
  } else {
    t28 = $[96];
  }
  let t29;
  if ($[97] !== handleLocationClick || $[98] !== selectedLocationForDetails) {
    t29 = <DialogFooter className="flex-row justify-end gap-2">{t28}<Button onClick={() => {
        if (selectedLocationForDetails) {
          handleLocationClick(selectedLocationForDetails.id);
        }
        closeDetailsModal();
      }} variant="primary">Select Location</Button></DialogFooter>;
    $[97] = handleLocationClick;
    $[98] = selectedLocationForDetails;
    $[99] = t29;
  } else {
    t29 = $[99];
  }
  let t30;
  if ($[100] !== t21 || $[101] !== t27 || $[102] !== t29) {
    t30 = <DialogContent className="max-w-md">{t21}{t27}{t29}</DialogContent>;
    $[100] = t21;
    $[101] = t27;
    $[102] = t29;
    $[103] = t30;
  } else {
    t30 = $[103];
  }
  let t31;
  if ($[104] !== isDetailsModalOpen || $[105] !== t30) {
    t31 = <Dialog open={isDetailsModalOpen} onOpenChange={closeDetailsModal}>{t30}</Dialog>;
    $[104] = isDetailsModalOpen;
    $[105] = t30;
    $[106] = t31;
  } else {
    t31 = $[106];
  }
  let t32;
  if ($[107] !== t17 || $[108] !== t19 || $[109] !== t31) {
    t32 = <div className="mb-2">{t12}{t13}{t17}{t19}{t31}</div>;
    $[107] = t17;
    $[108] = t19;
    $[109] = t31;
    $[110] = t32;
  } else {
    t32 = $[110];
  }
  let t33;
  if ($[111] !== t11 || $[112] !== t32) {
    t33 = <div data-testid="step-location" className={t11} key="locations-container">{t32}</div>;
    $[111] = t11;
    $[112] = t32;
    $[113] = t33;
  } else {
    t33 = $[113];
  }
  return t33;
};
export default Locations;
function _temp(service_0) {
  return service_0.isVirtual;
}
function _temp2(location_0) {
  return location_0.isVirtual;
}
function _temp3(location_1) {
  return !location_1.isVirtual;
}
function _temp4(a, b) {
  if (a.isServiceAvailable && !b.isServiceAvailable) {
    return -1;
  }
  if (!a.isServiceAvailable && b.isServiceAvailable) {
    return 1;
  }
  if (a.isServiceAvailable && b.isServiceAvailable) {
    if (!a.distance && !b.distance) {
      return 0;
    }
    if (!a.distance) {
      return 1;
    }
    if (!b.distance) {
      return -1;
    }
    return a.distance - b.distance;
  }
  return 0;
}
function _temp5(loc) {
  return loc.isServiceAvailable;
}
function _temp6(loc_2) {
  return loc_2.isServiceAvailable;
}